import * as React from 'react';

import { FormattedMessage } from 'react-intl';

import * as screenSizes from '~/components/shared/viewPorts';
import { outer } from '~/globalStyles';
import { styled } from '~/styled';

interface Props {
  onClick: (e: any) => void;
  state?: 'hover' | 'active';
}

interface ButtonProps {
  /**
   * Forces an appearance normally accessed with pseudoselectors. Used only for
   * testing.
   */
  state?: 'hover' | 'active';
}

const SubscribeButton = styled.button<ButtonProps>(({ theme }) => {
  return `
  display: flex;
  justify-content: center;
  align-items: center;

  height: ${theme.space.space40};
  width: auto;
  margin: ${theme.space.space8} 0 ${theme.space.space8} 0;
  padding: 10px ${theme.space.space16};

  font-size: 15px;
  font-weight: ${theme.fontWeights.medium};
  line-height: ${theme.fontSizes.fontsize20};
  border-radius: ${theme.space.space4};

  transition: background-color 300ms;
  flex: auto 0 0;
  color: ${outer.colors.green};
  border: 1px solid ${outer.colors.green};
  background-color: ${theme.colors.white};

  &:hover {
    cursor: pointer;
    color: #008647 !important; // not in theme
  }
  &:active {
    color: #007841 !important; // not in theme
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  ${screenSizes.mediaMaxWidthSmall} {
    width: 100%;
  }
`;
});

export default ({ onClick, state }: Props) => {
  return (
    <SubscribeButton type="submit" onClick={onClick} state={state}>
      <FormattedMessage id="newsletterSignup.button" />
    </SubscribeButton>
  );
};
